module.exports = __webpack_public_path__ + "media/images/sent-img-msg-cdf6737bbdbebae98d0d7ac2c9691b85.png";